import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import axios from 'axios'
import Toggle from 'react-toggle'
import 'react-toggle/style.css' // for ES6 modules
class CountryAdminListing extends React.Component {
  state = {
    countries: [],
    isLoading: false,
    isEditing: false,
    editingField: '',
    selectedId: null,
    latitude: '',
    longitude: '',
    order: '',
  }

  componentDidMount() {
    this.getCountryAdminListing()
  }

  getCountryAdminListing = async () => {
    this.setState({
      isLoading: true,
    })

    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true&all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            countries: res.data.data,
            isLoading: false,
          })
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onEdit = (id, lat, lng, field, order) => {
    this.setState({
      isEditing: true,
      editingField: field,
      selectedId: id,
      latitude: lat || '',
      longitude: lng || '',
      order: order || '',
    })
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSaveLatLng = async () => {
    const { selectedId, latitude, longitude, editingField } = this.state

    if (editingField === 'order') {
      await this.onSaveOrder()
      return
    }

    await axios
      .post(
        Constant.getAPI() + '/admin/update-status',
        {
          id: selectedId,
          lat: latitude,
          long: longitude,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: 'Updated..!',
            text: 'Lat/Long has been updated',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
          this.setState({ isEditing: false, editingField: '', selectedId: null, latitude: '', longitude: '', order: '' })
          this.getCountryAdminListing()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onSaveOrder = async () => {
    const { selectedId, order } = this.state
    await axios
      .put(
        Constant.getAPI() + '/multi-country/update-country-order',
        {
          country_id: selectedId,
          order: parseInt(order),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: 'Updated..!',
            text: 'Order has been updated',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
          this.setState({ isEditing: false, editingField: '', selectedId: null, order: '' })
          this.getCountryAdminListing()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleStatusChange = async (id, isActive, type = '') => {
    let data = {
      id: id,
    }

    if (type == 'forFlight') {
      data.for_flight = isActive
    } else if (type == 'is_admin') {
      data.is_admin = isActive
    } else {
      data.is_active = isActive
    }

    await axios
      .post(Constant.getAPI() + '/admin/update-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            toast: true,
            icon: 'success',
            position: 'top-end',
            title: 'Updated..!',
            text: 'Status has been Changed',
            showConfirmButton: false,
            timerProgressBar: true,
            timer: 2500,
          })
          this.getCountryAdminListing()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const allCountriesColumns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: 'img',
        label: 'Image',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return (
              <img
                src={value.includes('https://') ? value : Constant.getImage() + value}
                className="img-fluid img-40"
                alt="img"
                onError={(event) => {
                  event.currentTarget.src = './assets/images/no_image.png'
                }}
                style={{ border: '1px solid #00f' }}
              />
            )
          },
        },
      },
      {
        name: 'country_name_en',
        label: 'Country Name English',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'country_name_ar',
        label: 'Country Name Arabic',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'country_short_name',
        label: 'Country Short Name',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'country_code',
        label: 'Country Code',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'currency_en',
        label: 'Currency English',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'currency_ar',
        label: 'Currency Arabic',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'two_letter_code_en',
        label: 'Currency 2 letter: En',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'two_letter_code_ar',
        label: 'Currency 2 letter: Ar',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'no_max_length',
        label: 'Phone number max length',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0]
            const isEditingThis = this.state.isEditing && this.state.selectedId === id && this.state.editingField === 'order'
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {isEditingThis ? (
                      <input
                        type="number"
                        name="order"
                        className="form-control px-1 form-control-sm"
                        style={{ width: '80px', minWidth: '80px' }}
                        onChange={this.onInputChange}
                        value={this.state.order}
                      />
                    ) : (
                      <div className="form-control" style={{ width: '80px', minWidth: '80px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {value || '-'}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {isEditingThis ? (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                          onClick={this.onSaveLatLng}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                        </span>
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                          onClick={this.onEdit.bind(this, id, '', '', 'order', value)}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'lat',
        label: 'Latitude',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0]
            const lng = tableMeta.rowData[12]
            const isEditingThis = this.state.isEditing && this.state.selectedId === id && this.state.editingField === 'latitude'
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {isEditingThis ? (
                      <input
                        type="text"
                        name="latitude"
                        className="form-control px-1 form-control-sm"
                        style={{ width: '120px', minWidth: '120px' }}
                        onChange={this.onInputChange}
                        value={this.state.latitude}
                      />
                    ) : (
                      <div className="form-control" style={{ width: '120px', minWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {value || '-'}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {isEditingThis ? (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                          onClick={this.onSaveLatLng}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                        </span>
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                          onClick={this.onEdit.bind(this, id, value, lng, 'latitude')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'long',
        label: 'Longitude',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            const id = tableMeta.rowData[0]
            const lat = tableMeta.rowData[11]
            const isEditingThis = this.state.isEditing && this.state.selectedId === id && this.state.editingField === 'longitude'
            return (
              <div className="form-group">
                <div className="form-group">
                  <div className="input-group mb-3">
                    {isEditingThis ? (
                      <input
                        type="text"
                        name="longitude"
                        className="form-control px-1 form-control-sm"
                        style={{ width: '120px', minWidth: '120px' }}
                        onChange={this.onInputChange}
                        value={this.state.longitude}
                      />
                    ) : (
                      <div className="form-control" style={{ width: '120px', minWidth: '120px', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {value || '-'}
                      </div>
                    )}{' '}
                    <div className="input-group-append border">
                      {isEditingThis ? (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                          onClick={this.onSaveLatLng}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-check"></i>
                        </span>
                      ) : (
                        <span
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                          onClick={this.onEdit.bind(this, id, lat, value, 'longitude')}
                        >
                          <i className="f-15 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'for_flight',
        label: 'Flight Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={!!is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active, 'forFlight')}
              />
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={!!is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'is_admin',
        label: 'Admin',
        options: {
          filter: true,
          sort: true,
          display: localStorage.getItem('loged_In_role') === 'super-admin',
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={tableMeta.rowData[0]}
                checked={!!is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active, 'is_admin')}
              />
            )
          },
        },
      },
    ]

    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isLoading ? 'Loading data..!' : 'Sorry, No Record Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Country Admin List</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Country Admin List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          title={'Countries'}
                          className="table-responsive"
                          data={this.state.countries}
                          columns={allCountriesColumns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default CountryAdminListing
